<script lang="ts">
	import type {
		HDKnockoutEncounter,
		HDKnockoutEncounterGame
	} from '../types/responses/KnockoutStage.js';
	import type { ExtendedRow } from '../types/util/ExtendedRow.js';
	import type { TableCol } from '../types/util/TableCol.js';

	import Table from '#lib/components/Table.svelte';
	import { goto } from '$app/navigation';
	import dayjs from 'dayjs';

	let {
		encounter,
		divisionId
	}: {
		encounter: HDKnockoutEncounter;
		divisionId: string;
	} = $props();

	const gamesCols: TableCol[] = [
		{
			key: 'scheduledDate',
			label: 'Datum'
		},
		{
			key: 'scheduledTime',
			label: 'Zeit'
		},
		{
			key: 'homeTeamShortName',
			label: 'Heim'
		},
		{
			key: 'score',
			label: 'Ergebnis'
		},
		{
			key: 'awayTeamShortName',
			label: 'Gast'
		}
	];

	const games = $derived(
		encounter.games.map((game) => {
			return {
				...game
			} as ExtendedRow<HDKnockoutEncounterGame>;
		})
	);

	const winningTeam = $derived(encounter.teams.find((team) => team.id === encounter.winningTeamId));
</script>

<div class="bg-neutral w-full">
	<h3 class="border-accent mb-3 border-b-2 text-center text-lg">
		{encounter.longname} | Best of {encounter.bestOf}
	</h3>
	<div class="flex flex-col items-center">
		{#if winningTeam}
			<div class="text-xl">{winningTeam.shortname} 🏆</div>
		{/if}

		<div class="flex w-full flex-col justify-between gap-3 md:flex-row">
			<div class="flex w-full flex-col items-center justify-center gap-3">
				<div class="bg-neutral flex w-full grow flex-col items-center justify-center">
					<img
						src={`https://api.hockeydata.net/img/icehockey/ebel/team-logos/${divisionId}/${encounter.teams[0].id}.png`}
						class="h-24 w-24 object-contain"
						alt={encounter.teams[0].shortname}
					/>
					{encounter.teams[0].shortname}
				</div>
			</div>
			<div class="flex w-full items-center justify-center text-2xl">
				{encounter.teams[0].gamesWon}&nbsp;:&nbsp;{encounter.teams[1].gamesWon}
			</div>
			<div class="flex w-full flex-col items-center justify-center gap-3">
				<div class="bg-neutral flex w-full grow flex-col items-center justify-center">
					<img
						src={`https://api.hockeydata.net/img/icehockey/ebel/team-logos/${divisionId}/${encounter.teams[1].id}.png`}
						class="h-24 w-24 object-contain"
						alt={encounter.teams[1].shortname}
					/>
					{encounter.teams[1].shortname}
				</div>
			</div>
		</div>
		<div class="border-accent w-full border-t-2">
			<Table
				columns={gamesCols}
				rows={games}
				hideHeader
				tableClass="bg-neutral text-sm"
				onSelect={(row) => goto(`/match/${row.id}`)}
			>
				{#snippet data(row, col, getRowData)}
					{#if col.key === 'scheduledDate'}
						{dayjs(row.scheduledDate.sortValue).format('DD.MM.YYYY')}
					{:else if col.key === 'score'}
						{row.homeTeamScore}&nbsp;:&nbsp;{row.awayTeamScore}
					{:else}
						{getRowData(row, col.key)}
					{/if}
				{/snippet}
			</Table>
		</div>
	</div>
</div>
